import React, { useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { useNavigate, useLocation } from "react-router-dom";
import { ForgotPasswords } from "../../api/api";
import "../CounsellorallEditPages/CounsellorResetPassword.css";
import bgImage from "../../../assets/images/brown-background.jpg";
import Swal from "sweetalert2";

const validationSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required"),
});

const CounsellorResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { email } = location.state || {};

  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const values = {
        email,
        type: "counsellor",
      };

      const response = await ForgotPasswords(values);

      if (response?.success === true) {
        // alert(response?.msg);
        await Swal.fire({
          title: "Success!",
          text: response?.msg,
          icon: "success",
          confirmButtonText: "OK",
        });
        navigate("/CounsellorSidebar/Resetpassword", { state: { values } });
      } else {
        // alert(response?.msg || "Failed to send OTP.");
        Swal.fire({
          title: "Error",
          text: response?.msg || "Failed to send OTP.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      alert("Something went wrong. Please try again later.");
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="crp-wrapper"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="crp-card">
        <div className="crp-headingText">
          <p>Don't worry, it happens. We will send the OTP to this email.</p>
        </div>
        <Formik
          enableReinitialize
          initialValues={{ email: email || "" }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ handleSubmit, errors, touched }) => (
            <form onSubmit={handleSubmit} className="crp-form">
              <div className="crp-inputView">
                <span className="crp-icon">📧</span>
                <input
                  type="text"
                  value={
                    email
                      ? `${email[0]}${"X".repeat(5)}${email.slice(-13)}`
                      : ""
                  }
                  className="crp-textInput"
                  disabled
                />
              </div>
              {touched.email && errors.email && (
                <div className="crp-errorView">
                  <span className="crp-errorText">{errors.email}</span>
                </div>
              )}
              <button
                type="submit"
                className="crp-continueBtn"
                disabled={isLoading}
              >
                {isLoading ? "Loading..." : "Continue"}
              </button>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default CounsellorResetPassword;
